import type { CheckLocationArchivableResponseSchema } from '@libs/data-access/entities'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import type { CheckArchivableOptions } from '../location.api'
import { checkArchivable } from '../location.api'
import { locationsQueryKeys } from '../location.queryKeys'

export const useCheckLocationArchivable = (
  options: CheckArchivableOptions,
  queryOptions?: UseAppQueryOptions<CheckLocationArchivableResponseSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: locationsQueryKeys.checkArchivable(options.locationId),
    queryFn: () => checkArchivable(options)
  })
}
